export const StoreSchedulesType = {
  NORMAL: 'normal',
  HOLIDAYS: 'holidays',
  SPECIALS: 'specials',
};
